module.exports = __webpack_public_path__ + "media/promo/courses/images/footer-18db6ab8a7ef9c3e93609064fb25efb4.png";